// src/components/common/ProfileSection/ProfileSection.tsx
import React from 'react'

interface ProfileSectionProps {
  name: string
  role: string
  // status: any
  profilePic?: string
  initials?: string
}

const ProfileSection: React.FC<ProfileSectionProps> = ({
  name,
  role,
  profilePic,
  initials,
}) => {
  return (
    <div className="flex items-center gap-4">
      {profilePic ? (
        <img
          src={profilePic}
          alt={name}
          className="w-16 h-16 rounded-full object-cover"
        />
      ) : (
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gray-500 text-white text-xl font-bold">
          {initials}
        </div>
      )}
      <div>
        <h2 className="text-lg font-semibold">{name}</h2>
        <p className="text-sm text-gray-600">{role}</p>
        {/* <p className={`text-sm ${status === 0 ? "text-green-500" : "text-red-500"}`}>
          {status}
        </p> */}
      </div>
    </div>
  )
}

export default ProfileSection
